<mat-progress-spinner
  mode="indeterminate"
  class="spinner"
></mat-progress-spinner>
